import React from 'react'
import Icon from 'react-icon-base'

export default (props) => {
  return (
    <Icon viewBox='0 0 512 512' {...props}>
      <title id='Hamburger'>{props.title || 'Hamburger'}</title>
      <g><path d='M49.6 123.2h411.9c25.2 0 45.8-16 45.8-35.5s-20.6-35.5-45.8-35.5H49.6c-25.1 0-45.8 16-45.8 35.5s20.7 35.5 45.8 35.5zm411.9 97.3H49.6c-25.1 0-45.8 16-45.8 35.5s20.7 35.5 45.8 35.5h411.9c25.2 0 45.8-16 45.8-35.5s-20.5-35.5-45.8-35.5zm0 168.3H49.6c-25.1 0-45.8 16-45.8 35.5s20.7 35.5 45.8 35.5h411.9c25.2 0 45.8-16 45.8-35.5s-20.5-35.5-45.8-35.5z' /></g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/hamburger.js